import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Route } from "react-router-dom";
import "../src/assets/fonts.css";
import "../src/assets/bootstrap.min.css";
import "../src/assets/bootstrap-extended.min.css";
import "../src/assets/frest/colors.min.css";
import "../src/assets/frest/components.min.css";
import "../src/assets/frest/vertical-menu.min.css";
import "../src/assets/frest/vendors.min.css";
import "./index.css";
import "sweetalert2/dist/sweetalert2.min.css";
// import App from './App';
import * as serviceWorker from "./serviceWorker";
import Swal from "sweetalert2";
import Form from "./components/Form";
import Form2 from "./components/Form2";
import Form3 from "./components/Form3";
import Login from "./components/Login";
import AdministratorLogin from "./components/administrators/Login";
import Administrator from "./components/Administrator";
import MasterData from "./components/MasterData";
import ProtectedRoute from "./components/ProtectedRoute";

ReactDOM.render(
  <Router>
    <div>
      <Route exact path="/" component={Login} />
      <ProtectedRoute
        path="/form"
        component={Form}
        requiredFormStatus="form_1"
      />
      <ProtectedRoute
        path="/form-2"
        component={Form2}
        requiredFormStatus="form_2"
      />
      <ProtectedRoute
        path="/form-3"
        component={Form3}
        requiredFormStatus="form_3"
      />
      <Route path="/administrator/login" component={AdministratorLogin} />
      <Route exact path="/administrator" component={Administrator} />
      <Route exact path="/master-data" component={MasterData} />
    </div>
  </Router>,
  document.getElementById("root")
);
// ✅ Service Worker dimatikan untuk menghindari masalah cache
// Aplikasi ini memerlukan koneksi internet untuk Firebase, jadi tidak perlu offline capability
// Dengan mematikan service worker, update akan langsung terlihat oleh user tanpa perlu clear cache
serviceWorker.unregister();
